import React from 'react';
import { useTranslation } from 'react-i18next';
import { Code2, ExternalLink, Globe, Smartphone } from 'lucide-react';
import { CLI_NPM_PACKAGE_URL } from '../../common/constants';

const CLI_FEATURES = [
  { key: 'remote', Icon: Smartphone },
  { key: 'browser', Icon: Globe },
] as const;

export const CliSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-[#101827] text-white">
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:gap-10">
          <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg bg-teal-300/15 text-teal-200">
            <Code2 size={24} />
          </div>
          <div className="max-w-3xl">
            <p className="text-sm font-semibold uppercase text-teal-200">
              {t('landing.cli.eyebrow')}
            </p>
            <h2 className="mt-3 text-3xl font-bold leading-tight">{t('landing.cli.title')}</h2>
            <p className="mt-4 text-base leading-7 text-slate-300">
              {t('landing.cli.description')}
            </p>
            <a
              href={CLI_NPM_PACKAGE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center gap-2 rounded-lg bg-teal-300/15 px-4 py-2 text-sm font-semibold text-teal-200 transition-colors hover:bg-teal-300/25"
            >
              {t('landing.cli.npmLink')}
              <ExternalLink size={16} />
            </a>
          </div>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-2">
          {CLI_FEATURES.map(({ key, Icon }) => (
            <article key={key} className="rounded-lg border border-white/10 bg-white/[0.04] p-5">
              <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-teal-300/15 text-teal-200">
                <Icon size={20} />
              </div>
              <h3 className="font-semibold">{t(`landing.cli.features.${key}.title`)}</h3>
              <p className="mt-3 text-sm leading-6 text-slate-300">
                {t(`landing.cli.features.${key}.description`)}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
